import React, { useState } from 'react';
import Button from "@mui/material/Button";
import EditNoteIcon from "@mui/icons-material/EditNotifications";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import { useAxios } from '../../../core/useAxios';
import { APIMETHOD } from '../../../core/constant';

export const initialClientAddress = {
  site_name: '',
  address: '',
  scope: '',
  efte: '',
  contact_person: '',
  telephone_number: '',
  number_of_shifts: ''
}

const mapAddressData = (data: any) => {
  return {
    site_name: data.site_name,
    address: data.address,
    scope: data.scope,
    efte: data.efte,
    contact_person: data.contact_person,
    telephone_number: data.telephone_number,
    number_of_shifts: data.number_of_shifts,
    id: data.id
  }
}

export const addressReducer = (state: any, action: any) => {
  switch(action.type) {
    case 'SET_ADDRESS':
      return {
        ...state,
        [action.field]: action.payload
      }
    case 'UPDATE_ADDRESS':
      return { ...action.payload }
    case 'SET_INITIALFORM':
      return { ...action.payload }
    default:
      return state;
  }
}

const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '5px 8px',
  border: '1px solid #ccc',
  borderRadius: 4,
  fontSize: '0.875rem',
  boxSizing: 'border-box',
  outline: 'none',
};

const cellSx = { py: 1, px: 1.5, fontSize: '0.875rem' };
const headCellSx = { py: 1.25, px: 1.5, fontWeight: 600, fontSize: '0.85rem', whiteSpace: 'nowrap' as const, backgroundColor: '#f5f5f5' };

function ClientAddress(props: any) {
  const { state, dispatch, clientAdressList, setClientAdressList, clientDetails } = props;
  const { post, put, del } = useAxios({ showLoader: true });
  const [editedRowId, setEditedRowId] = useState<string | null>(null);
  const [newAddress, setNewAddress] = useState(initialClientAddress);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState<boolean>(false);
  const [addressToDeleteId, setAddressToDeleteId] = useState<string | null>(null);

  const handleAddAddress = (e: any) => {
    const targetName = e.target.name;
    const targetValue = e.target.value;

    if (editedRowId) {
      dispatch({
        type: 'SET_ADDRESS',
        field: targetName,
        payload: targetValue
      });
    } else {
      setNewAddress((prev) => ({ ...prev, [targetName]: targetValue }));
    }
  };

  const handleAddressSubmit = async () => {
    if (editedRowId) {
      const response: any = await put({
        url: APIMETHOD.address.ADDRESS_API + editedRowId + '/',
        data: { ...state, client: clientDetails?.id }
      });

      if (response) {
        const updatedAddressList = clientAdressList.map((data: any) => {
          if (data.id === editedRowId) {
            return response;
          }
          return data;
        });

        setClientAdressList(updatedAddressList);
        setEditedRowId(null);
        dispatch({
          type: 'SET_INITIALFORM',
          payload: initialClientAddress
        });
      } else {
        console.log('Server Error, Error Received while updating Address');
      }
    } else {
      const response: any = await post({
        url: APIMETHOD.address.ADDRESS_API,
        data: { ...newAddress, client: clientDetails?.id }
      });

      if (response) {
        setClientAdressList([...clientAdressList, response]);
        setNewAddress(initialClientAddress);
        dispatch({
          type: 'SET_INITIALFORM',
          payload: initialClientAddress
        });
      } else {
        console.log('Server Error, Error Received while creating Address');
      }
    }
  };

  const handleEdit = (data: any) => {
    setEditedRowId(data.id);
    dispatch({
      type: 'UPDATE_ADDRESS',
      payload: mapAddressData(data)
    });
  };

  const handleDeleteConfirmationOpen = (id: string) => {
    setAddressToDeleteId(id);
    setDeleteConfirmationOpen(true);
  };

  const handleDeleteConfirmationClose = () => {
    setAddressToDeleteId(null);
    setDeleteConfirmationOpen(false);
  };

  const handleDelete = async (id: string) => {
    handleDeleteConfirmationClose();

    await del({
      url: APIMETHOD.address.ADDRESS_API + id + '/'
    });

    const updatedAddressList = clientAdressList.filter((data: any) => data.id !== id);
    setClientAdressList(updatedAddressList);
  };

  return (
    <div>
      <TableContainer component={Paper} variant="outlined" sx={{ mt: 1 }}>
        <Table sx={{ tableLayout: 'fixed' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ ...headCellSx, width: '17%' }}>Site Name</TableCell>
              <TableCell sx={{ ...headCellSx, width: '32%' }}>Address</TableCell>
              <TableCell sx={{ ...headCellSx, width: '17%' }}>Scope Of Site</TableCell>
              <TableCell sx={{ ...headCellSx, width: '9%' }}>EFTE</TableCell>
              <TableCell sx={{ ...headCellSx, width: '11%' }}>No of Shifts</TableCell>
              <TableCell sx={{ ...headCellSx, width: '10%' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {clientAdressList.map((data: any) => (
              <TableRow key={data.id} sx={{ '&:nth-of-type(odd)': { backgroundColor: '#fafafa' } }}>
                <TableCell sx={cellSx}>
                  {editedRowId === data.id ? (
                    <input type="text" value={state.site_name} name="site_name" style={inputStyle} onChange={handleAddAddress} />
                  ) : data.site_name}
                </TableCell>
                <TableCell sx={cellSx}>
                  {editedRowId === data.id ? (
                    <input type="text" value={state.address} name="address" style={inputStyle} onChange={handleAddAddress} />
                  ) : data.address}
                </TableCell>
                <TableCell sx={cellSx}>
                  {editedRowId === data.id ? (
                    <input type="text" value={state.scope} name="scope" style={inputStyle} onChange={handleAddAddress} />
                  ) : data.scope}
                </TableCell>
                <TableCell sx={cellSx}>
                  {editedRowId === data.id ? (
                    <input type="text" value={state.efte} name="efte" style={inputStyle} onChange={handleAddAddress} />
                  ) : data.efte}
                </TableCell>
                <TableCell sx={cellSx}>
                  {editedRowId === data.id ? (
                    <input type="text" value={state.number_of_shifts} name="number_of_shifts" style={inputStyle} onChange={handleAddAddress} />
                  ) : data.number_of_shifts}
                </TableCell>
                <TableCell sx={cellSx}>
                  {editedRowId === data.id ? (
                    <Button size="small" variant="contained" color="success" startIcon={<CheckIcon />} sx={{ fontSize: '0.72rem', px: 1 }} onClick={handleAddressSubmit}>
                      Save
                    </Button>
                  ) : (
                    <Box sx={{ display: 'flex', gap: 0.5 }}>
                      <Button size="small" variant="outlined" sx={{ minWidth: 'auto', p: 0.4 }} onClick={() => handleEdit(data)}>
                        <EditNoteIcon sx={{ fontSize: 16 }} />
                      </Button>
                      <Button size="small" color="error" variant="outlined" sx={{ minWidth: 'auto', p: 0.4 }} onClick={() => handleDeleteConfirmationOpen(data.id)}>
                        <DeleteIcon sx={{ fontSize: 16 }} />
                      </Button>
                    </Box>
                  )}
                </TableCell>
              </TableRow>
            ))}
            <TableRow sx={{ backgroundColor: '#f0f4ff' }}>
              <TableCell sx={cellSx}>
                <input type="text" value={newAddress.site_name} name="site_name" style={inputStyle} placeholder="Site name" onChange={handleAddAddress} />
              </TableCell>
              <TableCell sx={cellSx}>
                <input type="text" value={newAddress.address} name="address" style={inputStyle} placeholder="Address" onChange={handleAddAddress} />
              </TableCell>
              <TableCell sx={cellSx}>
                <input type="text" value={newAddress.scope} name="scope" style={inputStyle} placeholder="Scope" onChange={handleAddAddress} />
              </TableCell>
              <TableCell sx={cellSx}>
                <input type="text" value={newAddress.efte} name="efte" style={inputStyle} placeholder="EFTE" onChange={handleAddAddress} />
              </TableCell>
              <TableCell sx={cellSx}>
                <input type="text" value={newAddress.number_of_shifts} name="number_of_shifts" style={inputStyle} placeholder="Shifts" onChange={handleAddAddress} />
              </TableCell>
              <TableCell sx={cellSx}>
                <Button size="small" variant="contained" startIcon={<AddIcon />} sx={{ fontSize: '0.72rem', px: 1, whiteSpace: 'nowrap' }} onClick={handleAddressSubmit}>
                  Add
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog
        open={deleteConfirmationOpen}
        onClose={handleDeleteConfirmationClose}
        aria-labelledby="delete-confirmation-dialog-title"
        aria-describedby="delete-confirmation-dialog-description"
      >
        <DialogTitle id="delete-confirmation-dialog-title">Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-confirmation-dialog-description">
            Are you sure you want to delete this address?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteConfirmationClose} color="primary">
            Cancel
          </Button>
          <Button onClick={() => handleDelete(addressToDeleteId || '')} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ClientAddress;
